module.exports = __webpack_public_path__ + "static/media/CheckInGold.07fbff01.svg";